import {gql} from '@apollo/client'

export const SET_DILIGENCIA_HISTORICO = gql`
  mutation SetDiligenciaHistorico($diligenciaHistorico: diligenciaHistorico!) {
    SetDiligenciaHistorico(diligenciaHistorico: $diligenciaHistorico) {
      id
      id_proprietario
    }
  }
`

export const PUT_DILIGENCIA_HISTORICO = gql`
  mutation PutDiligenciaHistorico($diligenciaHistorico: diligenciaHistorico!) {
    PutDiligenciaHistorico(diligenciaHistorico: $diligenciaHistorico) {
      id
      id_empresa
      id_proprietario
      id_terreno
      id_user
    }
  }
`

export const DELETE_DILIGENCIA_HISTORICO = gql`
  mutation DeleteDiligenciaHistorico($deleteDiligenciaHistoricoId: Float!) {
    DeleteDiligenciaHistorico(id: $deleteDiligenciaHistoricoId) {
      id
    }
  }
`
